export const getViewport = (pdfPage: any, scale: number) => {
    let viewport = {
        width: 0,
        height: 0,
    };
    viewport = pdfPage.getViewport({ scale });
    return viewport;
};
